module.exports = __webpack_public_path__ + "static/media/manovr-1.b4e19ceb.jpg";